<script>
import * as d3 from 'd3'
import CandelaComponent from '@/components/CandelaComponent'

export default {
  computed: {
    arc() {
      return d3.arc()
        .innerRadius(this.size * 0.5 - this.size * this.settings.inner_radius.value * 0.5)
        .outerRadius(this.size * 0.5)
    },
    arc_segments() {
      return this.pie(this.data)
    },
    colors() {
      return this.data.map((x, i) => {
        return this.settings.colors.value(i)
      })
    },
    pie() {
      return d3.pie()
        .sort(null)
        .value(d => d)
    }
  },
  data() {
    return {
      height: 128,
      size: 128,
      width: 128
    }
  },
  extends: CandelaComponent,
  methods: {
    on_resize() {
      const svg = this.$refs.svg
      this.width = svg ? svg.clientWidth : 128
      this.height = svg ? svg.clientHeight : 128
      this.size = Math.min(this.width, this.height)
    }
  },
  mounted() {
    setTimeout(() => {
      this.on_resize()
    }, 500)
  },
  name: 'donut-chart',
  props: {
    data: {type: Array, default: () => []},
    index: {type: Array, default: () => []},
    variable: {type: String, default: () => null}
  },
  watch: {
    frame() {
      this.on_resize()
    }
  }
}
</script>

<template>
<div v-resize='on_resize' class='candela-component flex-column'>
  <svg ref='svg' width='100%' height='100%'>
    <g :transform='`translate(${width * 0.5} ${height * 0.5})`'>
      <path v-for='(a, i) in arc_segments' :key='i' :d='arc(a)'
        :fill='colors[i]'/>
    </g>
  </svg>
  <candela-legend :colors='colors' :index='index' :title='variable'/>
</div>
</template>
